import React from "react";
import { useNavigate } from "react-router-dom";

const NaboraMerchant = ({ slug }) => {
  const navigate = useNavigate();

  const benefits = [
    {
      icon: "🌐",
      title: "Digital Presence",
      desc: "Showcase your products beyond your physical shop.",
    },
    {
      icon: "🎪",
      title: "Join Exhibitions",
      desc: "Participate in monthly neighbourhood exhibitions.",
    },
    {
      icon: "📍",
      title: "Nearby Customers",
      desc: "Connect with customers searching locally.",
    },
    {
      icon: "🎁",
      title: "Rewards & Growth",
      desc: "Build repeat customers through BOS rewards.",
    },
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <div className="py-8 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="text-yellow-300 uppercase tracking-[4px] text-sm mb-4">
            🏪 NABORA MERCHANT
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            Your Local Business Deserves A Digital Stage
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            Join Nabora and showcase your products, participate in neighbourhood
            exhibitions, connect with customers and grow with your community.
          </p>

          <button
            onClick={() => navigate("/nabora/merchant/register")}
            className="mt-6 px-6 py-3 bg-gradient-to-r from-fuchsia-500 to-violet-600 rounded-xl font-bold hover:scale-105 transition-all shadow-xl shadow-purple-500/40"
          >
            🚀 Enroll As Merchant
          </button>
        </div>
      </div>

      <div className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-xl lg:text-2xl font-bold text-cyan-200 mb-6">
            Why Merchants Choose Nabora
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {benefits.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/70 border border-white/10 rounded-3xl p-5 hover:border-purple-400/50 transition-all"
              >
                <div className="text-3xl mb-3">{item.icon}</div>

                <h3 className="text-lg font-bold text-white mb-2">
                  {item.title}
                </h3>

                <p className="text-slate-300 text-sm lg:text-base">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-4xl mx-auto text-center">
          <div className="text-4xl mb-3">🤝</div>

          <h2 className="text-xl lg:text-3xl font-bold text-white mb-3">
            Become Part Of Your Local Digital Economy
          </h2>

          <p className="text-slate-300 mb-6">
            Nabora connects neighbourhood merchants, customers, organisers and
            creators into one community-powered ecosystem.
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <button
              onClick={() => navigate("/nabora/exhibitions")}
              className="px-5 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              🎪 Explore Exhibitions
            </button>

            <button
              onClick={() => navigate("/finditlocal")}
              className="px-5 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
            >
              📍 Discover Local Marketplace
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaboraMerchant;
